import styled from "styled-components";


export const FooterContainer = styled.div`
    width: 100%;
    height: 20px;
    position: absolute;
    bottom:0;
    background-color: rgb(0,0,0);
    display: flex;
    align-items: center;
    justify-content: space-between;

`

export const FooterText = styled.p`
    font-size:1rem;
    margin: 0 10px;
`

export const FooterLink = styled.a `
    font-size: 1rem;
    text-decoration:none;
    color: #7F00FF;
`